import { Component, Input, OnInit } from '@angular/core';
import { DOWNLOAD_DATA, LOCKED_SM, LITE, SUCCESS_TICK, FAILED_CROSS } from 'src/defaultImages.js';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { UtilService } from 'src/app/util/util.service';
import { PaymentService } from 'src/app/common/services/payment.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { LanguageService } from 'src/app/common/services/language.service';
import { DateService } from 'src/app/common/services/date.service';
import { country } from 'src/app/common/enums/language';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {  NzModalService } from 'ng-zorro-antd/modal';
import { CollectionInfrastructureService } from 'src/app/collection-infrastructure/collection-infrastructure.service';

@Component({
  selector: 'app-locked-pos-after-promise',
  templateUrl: './locked-pos-after-promise.component.html',
  styleUrls: ['./locked-pos-after-promise.component.css'],
})
export class LockedPosAfterPromiseComponent implements OnInit {
  currency: string;
  @Input() popupData: any[];
  paymentDetails: any;
  subscription = new Subscription();
  lastDate;
  currentMonth;
  restaurantId;
  isIndo: boolean = false;
  paymentBody: any;
  paymentLiteBody: any;
  isLoading: boolean = false;
  images = {
    LOCKED_SM: LOCKED_SM,
    DOWNLOAD: DOWNLOAD_DATA,
    LITE: LITE,
    SUCCESS_TICK: SUCCESS_TICK,
    FAILED_CROSS: FAILED_CROSS
  };
  liteInfo: any = {
    WHATS_INCLUDED:[
      'User-Friendly Order Dashboard',
      'Detailed Order Reports',
      'Streamlined Inventory Management',
    ],
    WHATS_NOT_INCLUDED:[
      'QR Ordering Technology',
      'Customer Data and Insights'
    ]
  }
  tncChecked: boolean = false;
  showTnc: boolean = false;
  translationText;

  reoccurChecked: boolean = true;
  constructor(
    private _localStorage: LocalStorageService,
    private _util: UtilService,
    private _payment: PaymentService,
    private _curr: CurrencyService,
    private _collectionInfraService: CollectionInfrastructureService,
    private _lang: LanguageService,
    private translateService: TranslateService,
    private _modalService: NzModalService,
    private _dateService: DateService
  ) {
    this.currency = this._curr.getCurrency();
    this.lastDate = this._dateService.getLastDateOfMonthFormatted()
    this.currentMonth = this._dateService.returnLastDateMonth();
    this.restaurantId = this._localStorage.get('restaurant_id');
  }

  ngOnInit() {
    this.isIndo = this._lang.getDomain() === country.id.domain;
    this.setTranslations();
    this.paymentDetails = this.popupData;
    this.paymentBody = [
      {
        restaurant_id: this.restaurantId,
        amount: Math.abs(this.paymentDetails.finalBill),
      },
    ];
    this.paymentLiteBody = [
      {
        restaurant_id: this.restaurantId,
        amount: Math.abs(this.paymentDetails.switchToLiteAmount),
      },
    ];
    this.getRestaurantSettings(); 
  }

  async getRestaurantSettings() {
    try{
      this.reoccurChecked  = await this._payment.getRestaurantSettings(this.restaurantId);
    }catch(e){}
  }
  updateRestaurantSettings() {
    this._payment.updateRestaurantSettings(this.restaurantId,this.reoccurChecked);
  }

  reoccurCheckHandler(event) {
    if ((event || {}).hasOwnProperty('checked')) {
      this.reoccurChecked = event.checked;
    }
  }
  async openReOccurHowWorks() {
    const { ReoccurKnowMoreComponent } = await import(
      /* webpackPrefetch: true */ '../reoccur-know-more/reoccur-know-more.component'
    );
    const modal = this._modalService.create({
      nzClosable: false,
      nzContent: ReoccurKnowMoreComponent,
      nzBodyStyle: { padding: '20px' },
      nzStyle: { top: '45px' },
      nzFooter: null,
      nzWidth: 450,
      nzMaskClosable: false,
      nzComponentParams: {
        showRazorText: false,
      },
    });

  }
  setTranslations() {
    this.subscription.add(
      this.translateService.get(['AFTER_PROMISE']).subscribe((res) => {
        this.translationText = res.AFTER_PROMISE;
        this.liteInfo = {
          WHATS_INCLUDED:[
            this.translationText.WI_1,
            this.translationText.WI_2,
            this.translationText.WI_3
          ],
          WHATS_NOT_INCLUDED:[
            this.translationText.WNI_1,
            this.translationText.WNI_2
          ]
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  toggleTnc(){
    this.showTnc = !this.showTnc
  }

  download() {
    this.isLoading = true; // Set isLoading to true to show the loader

    this._collectionInfraService
      .download(this.restaurantId)
      .then((response) => {
        // Handle the successful download here
        this.isLoading = false; // Set isLoading to false to hide the loader
      })
      .catch((error) => {
        // Handle the error here
        this.isLoading = false; // Set isLoading to false to hide the loader
      });
  }
  askForReocurrInfoandPay(isPayForLite) {
    const options = isPayForLite ? { switch_to_lite: true } : {};
    this.updateRestaurantSettings();
    this._payment.payNow(this.paymentBody,this.reoccurChecked,options);
  }
}
